import { View } from 'react-native';
import React from 'react';
import { HireBanner, KeyboardScreenContainer } from '~/components';
import { useCheckout } from '~/stores';
import Footer from './components/Footer';

interface Props {
  children: React.ReactNode;
  isValid?: boolean;
  onSubmit: () => void;
}

const CheckoutLayout = ({ children, isValid = true, onSubmit }: Props) => {
  const { insurance } = useCheckout();

  if (!insurance) {
    return null;
  }

  const {
    name,
    description,
    banner: { web, mobile },
  } = insurance;

  return (
    <>
      <KeyboardScreenContainer
        showsVerticalScrollIndicator={false}
        footer={
          <Footer
            className="lg:hidden"
            isValid={!!isValid}
            onSubmit={onSubmit}
          />
        }
      >
        <View className="lg:flex-row flex flex-1 lg:flex-none lg:justify-center lg:mt-8">
          <HireBanner
            images={{
              mobile,
              web,
            }}
            insuranceName={name}
            insuranteDetail={description}
            className={
              ['marisa-auto', 'income-protection'].includes(insurance.type)
                ? 'h-[140px]'
                : ''
            }
          />

          <View className="flex-1 lg:flex-none lg:ml-24">
            <View className="p-6 flex-1 pb-0 lg:w-[400px] lg:py-0">
              {children}
            </View>

            <Footer
              className="hidden lg:block"
              isValid={!!isValid}
              onSubmit={onSubmit}
            />
          </View>
        </View>
      </KeyboardScreenContainer>
    </>
  );
};

export default CheckoutLayout;
